export const contactsData = {
  email: "fekinajd@gmail.com",
  phone: "+216 51 857 357",
  address: "Tunisia, Ben Arous, Boumhal",

  sheetAPI: "",
};
